export const Pencil = () => (
  <g>
    <path
      d='M15.772 6C15.6053 6 15.432 6.06667 15.3054 6.19333L14.0855 7.41333L16.5852 9.91333L17.805 8.69333C18.065 8.43333 18.065 8.01333 17.805 7.75333L16.2452 6.19333C16.1119 6.06 15.9453 6 15.772 6ZM13.3723 8.12667L6 15.5V18H8.49965L15.872 10.6267L13.3723 8.12667Z'
      fill='currentColor'
    />
  </g>
)
